import { NewConvertSection } from './memberTypes';

export const newConvertGuideEs: NewConvertSection[] = [
  {
    id: 'bienvenida-al-reino',
    title: 'Bienvenido al Reino: qué significa ser un nuevo miembro',
    content: `
Convertirse en un nuevo miembro no es el final de un viaje, sino el comienzo de una vida transformada. Has entrado por la puerta (2 Nefi 31) y ahora comienzas el sendero del discipulado.

Este sendero requiere:

- amarte a ti mismo como hijo o hija de Dios,
- aprender a escuchar al Espíritu,
- integrarte en una comunidad del convenio,
- fortificar tu fe mediante hábitos diarios.

La Iglesia es una familia espiritual, no un club social. Tu crecimiento importa, tus preguntas importan, tu historia importa.
    `,
    bullets: [
      'Tu bautismo es un convenio real con Dios.',
      'El Espíritu Santo será tu compañero constante en la medida en que busques Su influencia.',
      'Tu camino es individual, pero nunca solitario.',
      'Tienes un lugar en el Reino: eres parte del recogimiento de Israel.',
    ],
    scriptures: [
      { ref: '2 Nefi 31:17–20' },
      { ref: 'Juan 3:5' },
      { ref: 'Mosíah 18:8–10' },
    ],
    tips: [
      'No compares tu progreso con el de otros.',
      'Lleva un diario espiritual los primeros 90 días.',
      'Ora cada día específicamente para sentir la compañía del Espíritu.',
    ],
  },
  {
    id: 'integracion-al-barrio',
    title: 'Integración al barrio y creación de pertenencia espiritual',
    content: `
Un nuevo converso florece cuando desarrolla amistades, conexiones espirituales y oportunidades reales de servir. La pertenencia precede al comportamiento.

La integración no es automática: se cultiva con esfuerzo de ambos lados —tu deseo de participar y la disposición del barrio de acogerte.

Tres pilares sostienen tu integración:

1. **Relaciones** — Amistades sinceras que edifiquen tu fe.
2. **Apoyo espiritual** — Personas que te acompañen en tus primeros pasos.
3. **Oportunidades de servir** — Pequeñas asignaciones que fortalezcan tu identidad como miembro.
    `,
    bullets: [
      'Siéntate con una familia diferente cada domingo.',
      'Participa en actividades sociales del barrio.',
      'Comparte tus preguntas abiertamente con tus líderes.',
      'Acepta invitaciones de visitas, Noche de Hogar o estudio de las Escrituras.',
    ],
    scriptures: [
      { ref: 'Moroni 6:4–5' },
      { ref: 'Hechos 2:42–47' },
    ],
    tips: [
      'Identifica a DOS personas con quienes te sientas seguro hablando.',
      'Pide una bendición del sacerdocio si necesitas fortaleza.',
      'Practica contar tu conversión en 2 minutos: esto fortalece tu identidad espiritual.',
    ],
  },
  {
    id: 'sacerdocio-aaronico',
    title: 'Introducción al Sacerdocio Aarónico',
    content: `
Si eres varón y tienes 12 años o más, puedes recibir el Sacerdocio Aarónico. Normalmente los nuevos conversos reciben primero esta autoridad antes del Sacerdocio de Melquisedec.

El Sacerdocio Aarónico es:

- preparatorio,
- centrado en el servicio,
- enfocado en la Santa Cena,
- un espacio para aprender reverencia, responsabilidad y pureza.

La clave del Aarónico es la **dignidad**, no la perfección.
    `,
    bullets: [
      'Aprenderás sobre la Santa Cena y cómo prepararla.',
      'Participarás en reuniones del cuórum.',
      'Servirás a otros mediante asignaciones sencillas.',
      'Desarrollarás hábitos de oración, estudio y obediencia.',
    ],
    scriptures: [
      { ref: 'DyC 20:46–59' },
      { ref: '1 Samuel 3' },
    ],
    tips: [
      'Pide un mentor espiritual del cuórum.',
      'Aprende de memoria la oración sacramental.',
      'Pregunta qué significa servir con reverencia.',
    ],
  },
  {
    id: 'sacerdocio-melquisedec',
    title: 'Preparación para el Sacerdocio de Melquisedec',
    content: `
El Sacerdocio de Melquisedec es un paso sagrado. Requiere madurez espiritual, un testimonio firme de Jesucristo y un patrón continuo de arrepentimiento.

Este sacerdocio te permite:

- bendecir,
- consolar,
- guiar espiritualmente,
- ministrar con poder,
- preparar a tu familia para las bendiciones del templo.

Tu obispo y presidente de estaca te guiarán en este proceso.
    `,
    bullets: [
      'Desarrolla un patrón diario de arrepentimiento.',
      'Habla con tu obispo sobre tu preparación.',
      'Participa en ministración con tu compañero asignado.',
      'Sirve proactivamente sin esperar invitación.',
    ],
    scriptures: [
      { ref: 'DyC 84:33–44' },
      { ref: 'DyC 107' },
    ],
    tips: [
      'Lleva un registro de tus impresiones del Espíritu.',
      'Aprende a reconocer tus dones espirituales.',
      'Pídele a Dios guía para prepararte para liderar en tu hogar.',
    ],
  },
  {
    id: 'primer-visita-al-templo',
    title: 'Tu primera visita al templo',
    content: `
Los templos son casas sagradas del Señor. Los nuevos miembros pueden entrar al templo para **bautismos por los muertos** poco después de bautizarse, si tienen una recomendación limitada vigente.

En el templo sentirás:

- paz intensa,
- claridad espiritual,
- renovación de propósito,
- un sentido profundo de pertenencia.

Los obreros del templo te guiarán paso a paso: nunca estarás solo.
    `,
    bullets: [
      'Usarás ropa blanca como símbolo de pureza.',
      'Participarás en ordenanzas vicarias por tus antepasados.',
      'Escucharás palabras de consuelo y esperanza.',
      'Sentirás la presencia del Espíritu Santo.',
    ],
    scriptures: [
      { ref: 'DyC 124:39' },
      { ref: '1 Corintios 15:29' },
    ],
    tips: [
      'Ora para sentir paz antes de tu visita.',
      'Ve acompañado de tus misioneros o tu líder.',
      'Comparte lo que sentiste en tu diario espiritual.',
    ],
  },
  {
    id: 'recomendacion-templo',
    title: 'La recomendación para el templo y la dignidad',
    content: `
Obtener tu recomendación para el templo es un paso sagrado. Las preguntas no son exámenes; son una conversación espiritual entre tú y Dios, mediante Sus siervos.

Se te preguntará por:

- tu fe en Jesucristo,
- tu arrepentimiento,
- tu obediencia,
- tu lealtad al convenio,
- tu honestidad,
- tu vida moral,
- tu relación con el Espíritu.

No necesitas ser perfecto. Necesitas ser honesto, humilde y esforzarte cada día.
    `,
    bullets: [
      'Pide una cita con tu obispo con anticipación.',
      'Sé completamente honesto y transparente.',
      'Comparte tus progresos, no solo debilidades.',
      'Recuerda que Dios es más misericordioso que estricto.',
    ],
    scriptures: [
      { ref: 'Salmos 24:3–4' },
      { ref: 'DyC 97:8' },
    ],
    tips: [
      'Haz autoevaluación semanal de tu dignidad.',
      'No temas hacer preguntas durante la entrevista.',
      'Acude con disposición a obedecer y aprender.',
    ],
  },
  {
    id: 'primeros-90-dias',
    title: 'Tus primeros 90 días: ruta espiritual del nuevo miembro',
    content: `
Los primeros 90 días son críticos. Lo que hagas en este periodo determina en gran medida tu crecimiento espiritual y tu estabilidad en la Iglesia.

Tu ruta recomendada:

- Semana 1–4: fortalecer hábitos espirituales.
- Semana 5–8: integrarte en el barrio.
- Semana 9–12: servir y preparar tu visita al templo.
    `,
    bullets: [
      'Estudia cada día 10 minutos del Libro de Mormón.',
      'Asiste a la Iglesia sin faltar por 8 semanas.',
      'Ora por nombre por tus ministros y líderes.',
      'Participa en una actividad de servicio.',
    ],
    scriptures: [
      { ref: 'Mosíah 5' },
      { ref: '3 Nefi 18:18–20' },
    ],
    tips: [
      'Pide ayuda cuando la necesites.',
      'Sé paciente con tu proceso.',
      'Identifica una meta espiritual mensual.',
    ],
  },
];

